import React, { useEffect, useState } from "react";
import "./style.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { dentalIcons } from "../../utils-icons/dentalIcons";
import { useSelector } from "react-redux";

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const isEditProject = useSelector(
    (state) => state.general.isEditProject || false
  );
  const isEditCase = useSelector((state) => state.general.isEditCase || false);
  const isRecordUpdate = useSelector(
    (state) => state.dental?.isRecordUpdate || false
  );

  const queryParams = new URLSearchParams(location.search);
  const case_Type = queryParams.get("case_type");

  const selectedProjectDetailTab = useSelector(
    (state) => state.general?.selectedProjectDetailTab || "all"
  );

  const routeNames = {
    "/dental-identification": "Home",
    "/dental-identification/dashboard": "Dashboard",
    "/dental-identification/projects": "Project Details",
    "/dental-identification/projects/new-project": isEditProject
      ? "Edit Project"
      : "Add Project",
    "/dental-identification/projects/details": "Case Details",
    "/dental-identification/projects/details/case-registration/am": isEditCase
      ? "Edit AM Case"
      : "Add AM Case",
    "/dental-identification/projects/details/case-registration/pm": isEditCase
      ? "Edit PM Case"
      : "Add PM Case",
    "/dental-identification/projects/details/case/add-dental-record":
      case_Type === "pm"
        ? isRecordUpdate
          ? "Edit PM Record"
          : "Add PM Record"
        : isRecordUpdate
        ? "Edit AM Record"
        : "Add AM Record",
    "/dental-identification/projects/details/case/results": "Record Comparison",
    "/dental-identification/projects/details/case/all-records":
      "PM Investigation",
    "/dental-identification/profile": "My Profile",
    "/dental-identification/support": "Support",
    "/dental-identification/settings": "Settings",
    "/dental-identification/about-us": "About Us",
    "/dental-identification/permission-denied": "Permission",
  };
  useEffect(() => {
    const pathnameParts = location.pathname.split("/").filter(Boolean);
    let currentPath = "";
    let crumbs = [];

    pathnameParts.forEach((part) => {
      currentPath += `/${part}`;

      const isCaseManagementRoute =
        currentPath ===
          "/dental-identification/projects/details/case-registration/am" ||
        currentPath ===
          "/dental-identification/projects/details/case-registration/pm" ||
        currentPath ===
          "/dental-identification/projects/details/case/add-dental-record";

      const isComparisonRoute =
        currentPath ===
          "/dental-identification/projects/details/case/results" ||
        currentPath ===
          "/dental-identification/projects/details/case/all-records";

      if (isCaseManagementRoute) {
        crumbs.push({
          name: "Case Management",
          path: "/dental-identification/projects/details",
        });
      }

      if (isComparisonRoute) {
        crumbs.push({
          name: "Case Analysis",
          path: "/dental-identification/projects/details",
        });
      }

      if (
        routeNames[currentPath] &&
        !crumbs.some((c) => c.path === currentPath)
      ) {
        crumbs.push({ name: routeNames[currentPath], path: currentPath });
      }
    });

    // ✅ Ensure "Home" is always the first breadcrumb
    if (crumbs[0]?.name !== "Home") {
      crumbs.unshift({
        name: "Home",
        path: "/dental-identification/dashboard",
      });
    }

    setBreadcrumbs(crumbs);
  }, [location]);

  const handleClick = (path, index) => {
    if (index < breadcrumbs.length - 1) {
      if (
        path === "/dental-identification/projects/details" || // Case Details
        path ===
          "/dental-identification/projects/details/case-registration/am" ||
        path ===
          "/dental-identification/projects/details/case-registration/pm" ||
        path ===
          "/dental-identification/projects/details/case/add-dental-record"
      ) {
        navigate(-1); // ✅ Keep state when navigating
      } else if (path === "/dental-identification") {
        navigate("/dental-identification/dashboard");
      } else {
        navigate(path);
      }
    }
  };

  const renderTabText = () => {
    if (selectedProjectDetailTab === "details") {
      return "Case Analysis";
    } else if (selectedProjectDetailTab === "cases") {
      return "Case Management";
    } else if (selectedProjectDetailTab === "traceability") {
      return "Case Traceability";
    } else {
      return "Case Collaboration";
    }
  };

  return (
    <nav className="breadcrumb">
      {breadcrumbs.map((crumb, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <span className="breadcrumb-separator">
              <img
                src={dentalIcons.breadCrumbIcon}
                className="breadcrumb-icon"
              />
            </span>
          )}
          {index === breadcrumbs.length - 1 ? (
            <span className="breadcrumb-active">
              {crumb.name}

              {crumb.path === "/dental-identification/projects/details" && (
                <>
                  <img
                    src={dentalIcons.breadCrumbIcon}
                    className="breadcrumb-icon"
                    style={{ margin: "0 10px" }}
                  />
                  {renderTabText()}
                </>
              )}
            </span>
          ) : (
            <Link
              className="breadcrumb-link"
              to={
                crumb.path === "/dental-identification"
                  ? "/dental-identification/dashboard"
                  : crumb.path
              }
              onClick={(e) => {
                e.preventDefault();
                handleClick(crumb.path, index);
              }}
            >
              {crumb.name}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
